const drupalSettingsFunc = (testField, ...globalKeys) => {
  const drupal = global.window && window.drupalSettings;
  if (!drupal) return {};

  var componentConfig = {};
  if (testField && drupal.pdb){
    const pdbConfig = drupal.pdb.configuration;
    for (var configId in pdbConfig) {
      if (pdbConfig[configId][testField] !== undefined) {
        componentConfig = pdbConfig[configId];
        break;
      }
    }
  }

  if (global.window && window.drupalSettings.globalvariables) {
    globalKeys.forEach((k) => {
      if (window.drupalSettings.globalvariables[k]) {
        Object.assign(componentConfig, window.drupalSettings.globalvariables[k]);
      } else {
        Object.assign(componentConfig, window.drupalSettings.globalvariables);
      }
    });
  }

  const labels = {};
  for(var key in componentConfig) {
    var multiKeys = key.split('_');
    if(multiKeys.length === 1) {
      //single key only
      labels[key] = componentConfig[key];
      continue;
    }

    labels[multiKeys[0]] = labels[multiKeys[0]] || {};
    labels[multiKeys[0]][multiKeys[1]] = componentConfig[key];
  }  

  return labels;
};

const globalVariablesFunc = () =>  {

  if(global.window){
    return window.drupalSettings?.globalvariables || {};
  }
  else
   return {}
}

export default drupalSettingsFunc;
export { globalVariablesFunc };
